import { render, staticRenderFns } from "./WHCategories.vue?vue&type=template&id=7829621b&"
import script from "./WHCategories.vue?vue&type=script&lang=js&"
export * from "./WHCategories.vue?vue&type=script&lang=js&"
import style0 from "./WHCategories.vue?vue&type=style&index=0&id=7829621b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports